module.exports = __webpack_public_path__ + "img/button3.56a17638.png";